import React from 'react';
 import bg from '../../images/Sajjad_Sadiq_Herder_Content.jpg'
import './HeaderContent.css'
import { BsCloudDownload } from 'react-icons/bs';

const HeaderContent = () => {
    return (
        <div className="headerContent">
        <section className="headerContainer">
            <div className="row">
                <div className="col-md-6 d-flex align-items-center mt-5">
                    <div>
                        <p className="">Hi There, I'm</p>
                        <h2 className="nameTitle">Sajjad Sadiq</h2>
                        <p>Junior MERN Stack Developer</p>
                        <div className="d-flex">
                            <button className="btn btn-outline-danger mr-3">Contact Me</button>
                            <button className="btn btn-danger"><a className="resumeLink" target="_blank" href="https://drive.google.com/file/d/10T-0FPRj7y0lbyVdcQwO8y7YW1XjNVLs/view?usp=sharing"><BsCloudDownload /> Resume</a></button>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 mt-5">
                    <img className="imgSize img-fuild" src={bg} alt="" />
                </div>
            </div>
        </section>
        </div>
    );
};

export default HeaderContent;